import { render, staticRenderFns } from "./ModalVatPrompt.vue?vue&type=template&id=65f0b94c&lang=pug&"
import script from "./ModalVatPrompt.vue?vue&type=script&lang=js&"
export * from "./ModalVatPrompt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports